<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchBilling">
                    <input class="form-control" v-model="search.no" placeholder="เลขใบวางบิล"/>
                    <multiselect
                            v-model="search.sale"
                            class="form-control select"
                            :options="OptionSeller"
                            :show-labels="false"
                            placeholder="กรุณาเลือกเซลล์"
                            label="name"
                            track-by="id">
                    </multiselect>
                    <!-- Search By Date Range -->
                    <date-picker
                            v-model="search.date"
                            :format="changeFormat"
                            :lang="lang"
                            placeholder="ระหว่างวันที่ ~ ถึงวันที่"
                            confirm
                            range>
                    </date-picker>&nbsp

                    <button @click="searchBilling"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                </form>
            </div>
        </nav>

        <b-nav tabs>
            <b-nav-item @click="onChangeStatus('')" router-link to="/accounting/billing/billings" exact>
                ทั้งหมด
                <template v-if="billingCounts.all">
                    ({{ billingCounts.all }})
                </template>
            </b-nav-item>&nbsp
            <b-nav-item @click="onChangeStatus(1)" router-link to="/accounting/billing/billings/status/1">
                ยังไม่ได้ชำระ
                <template v-if="billingCounts.pending">
                    ({{ billingCounts.pending }})
                </template>
            </b-nav-item>&nbsp
            <b-nav-item @click="onChangeStatus(2)" router-link to="/accounting/billing/billings/status/2">
                ชำระแล้ว
                <template v-if="billingCounts.paid">
                    ({{ billingCounts.paid }})
                </template>
            </b-nav-item>&nbsp
            <!--<b-nav-item @click="onChangeStatus(3)" router-link to="/accounting/billing/billings/status/3">-->
                <!--ตรวจสอบแล้ว-->
                <!--<template v-if="billingCounts.approved">-->
                    <!--({{ billingCounts.approved }})-->
                <!--</template>-->
            <!--</b-nav-item>&nbsp-->
            <b-nav-item @click="onChangeStatus(4)" router-link to="/accounting/billing/billings/status/4">
                ยกเลิก
                <template v-if="billingCounts.cancel">
                    ({{ billingCounts.cancel }})
                </template>
            </b-nav-item>&nbsp
        </b-nav>

        <router-view />
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import moment from "moment"
    import DatePicker from 'vue2-datepicker'
    import Multiselect from "vue-multiselect"

    export default {
        components: {
            DatePicker,
            Multiselect
        },
        name: "billing-tabs",
        props: ["statusId"],
        data() {
            return {
                search: {
                    seller_id: null,
                    date: [],
                    no : ''
                },
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        console.log(moment(date).format('DD/MM/'+year));
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        computed: {
            ...mapState({
                billingCounts: state => {
                    return state.Billing.billingCounts
                },
                dataPaginate:state=>{
                    return state.Billing.dataPaginate
                },
                OptionSeller: state =>{
                    return state.Seller.data;
                },
            })
        },
        created() {
            this.$store.dispatch("Billing/setStatus");
            this.$store.dispatch("Billing/setBillingCounts");
            this.search = {
                seller_id: "",
                sale : '',
                date: [],
                no : '',
            }
        },
        methods: {
            setSearchSellerId(){
              if(this.search.sale){
                  this.search.seller_id = this.search.sale.id;
              }else{
                  this.search.seller_id = "";
              }
            },
            onChangeStatus(statusId) {
                console.log(statusId);
                this.dataPaginate.current_page = 1;
                this.setSearchSellerId();
                this.search.date = [];
                this.$store.dispatch("Billing/setStatus", statusId)
                    .then(() => this.$store.dispatch("Billing/setBillings",{
                        data : this.search
                    }))
            },
            searchBilling() {
                this.dataPaginate.current_page = 1;
                this.setSearchSellerId();
                let start_date = ''; let end_date = '';
                if(this.search.date.length > 0 && this.search.date[0]){
                    start_date = moment(this.search.date[0]).format('YYYY-MM-DD');
                    end_date = moment(this.search.date[1]).format('YYYY-MM-DD');
                }
                this.$store.dispatch("Billing/setSearch", {
                    seller_id: this.search.seller_id,
                    start_date: start_date,
                    end_date: end_date,
                    no : this.search.no,
                })
                    .then(() => this.$store.dispatch("Billing/setBillings",{
                    data : this.search
                }))
            },
        }
    }
</script>

<style lang="scss" scoped>
    .select {
        border: 0;
    }
</style>
